import React, {FC, useEffect, useState} from 'react';
import {Form, Formik} from 'formik';

import '../../components/pages/groups/group-container/lessons/add-lesson/form/form.css'

import {ReactComponent as CloseIcon} from '../../assets/form/close-form.svg';
import {useAppDispatch, useAppSelector} from "common/hook";
import {useInputWithFocus} from "common/hook/useInputWithFocus";
import {setProblemsClassAC} from "app/popups-reducer";
import TextArea from "antd/es/input/TextArea";
import {fetchProblems} from "features/model/service/groups/groups-lessons/fetch-problems/fetchProblems";
import {useParams} from "react-router-dom";
import {fetchLessonsId} from "features/model/service/groups/lessons/fetchLessonsId";

interface MyFormValues {
    problem1: boolean;
    problem2: boolean;
    problem3: boolean;
    problem4: boolean;
    noteText: string;
}


export const FormProblemsClass: FC = () => {
    const dispatch = useAppDispatch()
    const {lessonsId} = useParams();
    const {isFilled, handleFocus, handleBlur} = useInputWithFocus([false]);
    const problemsData = useAppSelector(state => state.problems.data)
    const [text, setText] = useState(problemsData.comment || '')
    const [absenceOfStudents, setAbsenceOfStudents] = useState(problemsData.absenceOfStudents)
    const [technicalProblems, setTechnicalProblems] = useState(problemsData.technicalProblems)
    const [lateCancellation, setLateCancellation] = useState(problemsData.lateCancellation)
    const [other, seOther] = useState(problemsData.other)

    useEffect(() => {
        dispatch(fetchProblems({lessonsId: lessonsId}));
    }, [])

    useEffect(() => {
        setText(problemsData.comment || '');
    }, [problemsData.comment]);


    useEffect(() => {
        if (!other) {
            setText('');
        }
    }, [other]);

    useEffect(() => {
        setText(problemsData.comment)
        setAbsenceOfStudents(problemsData.absenceOfStudents)
        setTechnicalProblems(problemsData.technicalProblems)
        setLateCancellation(problemsData.lateCancellation)
    }, [problemsData])


    const onClickHandler = () => {
        dispatch(setProblemsClassAC(false))
    }

    const handleSubmit = async (values: MyFormValues) => {
        try {
            const requestData = {
                absence_of_students: values.problem1,
                technical_problems: values.problem2,
                late_cancellation: values.problem3,
                other: values.problem4,
                users_ids: [],
                comment: values.noteText,
            };
            await dispatch(fetchProblems({lessonsId: lessonsId, requestData: requestData}));
            await dispatch(fetchLessonsId(lessonsId));
            onClickHandler();
        } catch (error) {

        }
    };

    return (
        <Formik
            initialValues={{
                problem1: absenceOfStudents,
                problem2: technicalProblems,
                problem3: lateCancellation,
                problem4: other,
                noteText: text,
            }}
            enableReinitialize={true}
            onSubmit={handleSubmit}
        >
            {() => (
                <>
                    <p className="h3 popup-title">Проблемы занятия</p>
                    <Form className="form">
                        <div className="fields-row">
                            <div className="field">
                                <div className="checkbox-group">
                                    <div className="checkbox-item grid-view">
                                        <input
                                            id="problem-inp"
                                            name="problem-inp"
                                            type="checkbox"
                                            disabled={true}
                                            checked={absenceOfStudents}
                                            onChange={() => setAbsenceOfStudents(!absenceOfStudents)}
                                        />
                                        <label style={{color: '#002e33'}} htmlFor="problem-inp">Отсутствие
                                            студента</label>
                                        <div className="students-number sub-item">
                                            {problemsData.users?.items.map((el, index) => {
                                                return (
                                                    <div key={index} className="avatar">
                                                        <img src={el.avatar} alt={el.avatar}/>
                                                    </div>
                                                );
                                            })}
                                            <span className="num">{problemsData.users?.count}</span>
                                        </div>
                                    </div>

                                    <div className="checkbox-item">
                                        <input
                                            id="problem-inp2"
                                            name="problem-inp2"
                                            type="checkbox"
                                            checked={technicalProblems}
                                            onChange={() => setTechnicalProblems(!technicalProblems)}
                                        />
                                        <label htmlFor="problem-inp2">Технические проблемы</label>
                                    </div>
                                    <div className="checkbox-item">
                                        <input
                                            id="problem-inp3"
                                            name="problem-inp3"
                                            type="checkbox"
                                            checked={lateCancellation}
                                            onChange={() => setLateCancellation(!lateCancellation)}
                                        />
                                        <label htmlFor="problem-inp3">Поздняя отмена</label>
                                    </div>
                                    <div className="checkbox-item">
                                        <input
                                            id="problem-inp4"
                                            name="problem-inp4"
                                            type="checkbox"
                                            checked={other}
                                            onChange={() => seOther(!other)}
                                        />
                                        <label htmlFor="problem-inp4">Другое</label>
                                    </div>
                                </div>
                            </div>
                        </div>
                        <div className="fields-row">
                            <div className={`field ${text ? "filled" : ""}`}>
                                <label
                                    className={`field-name ${text ? "filled" : ""}`}>
                                    Комментарий
                                </label>
                                <div className="textarea-box">
                                    <TextArea
                                        className={`form-control ${!other ? 'input-disabled' : ''}`}
                                        name="noteText"
                                        value={text}
                                        onFocus={() => handleFocus(0)}
                                        onBlur={handleBlur}
                                        autoSize={{minRows: 3, maxRows: 10}}
                                        onChange={(event) => {
                                            const newText = event.target.value;
                                            setText(newText);
                                        }}
                                        disabled={!other}
                                    />
                                </div>
                            </div>
                        </div>
                        <button type="submit" className="btn full-width"><span>Сохранить изменения</span></button>
                    </Form>
                    <span className="js-close-popup" onClick={onClickHandler}>
            <CloseIcon/>
          </span>
                </>
            )}
        </Formik>
    );
};
